module.exports = __webpack_public_path__ + "static/media/6.83fc5aea.jpg";